import { Theme } from "../.themes";
import { BrandsEnum } from "../enums";
import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  component: {
    [theme.breakpoints.up("md")]: {
      margin: 16,
    },
    width: 488,
    display: theme.addOnCard?.component?.display,
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      marginBottom: 12,
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: 16,
    },
  },
  card: {
    backgroundColor: theme.brand === BrandsEnum.Renault ? "#FFFFFF" : "transparent",
    position: "relative",
    border: theme.addOnCard?.card?.border,
    width: "100%",
    padding: theme.addOnCard?.card?.padding,
    borderRadius: theme.addOnCard?.card?.borderRadius ?? 0,
    [theme.breakpoints.down("md")]: {
      padding: 16,
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  cardSelected: {
    position: "relative",
    width: "100%",
    border: theme.addOnCard?.cardSelected?.border,
    padding: theme.addOnCard?.cardSelected?.padding,
    backgroundColor: theme.addOnCard?.cardSelected?.backgroundColor,
    display: "flex",
    flexDirection: "column",
    borderRadius: theme.addOnCard?.card?.borderRadius ?? 0,
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      padding: 16,
    },
  },
  cardActions: {
    display: "block",
    paddingLeft: 0,
    paddingRight: 0,
    ...theme.addOnCard?.cardActions,
  },
  checkMark: {
    position: "absolute",
    top: 0,
    right: 0,
    "&> svg": {
      fontSize: "3rem",
    },
    ...theme?.addOnCard?.checkmark,
  },

  rightAlign: {
    textAlign: "right",
  },
  content: {
    textAlign: "left",
    padding: `${theme.spacing(1)}px 0`,
    ...theme.addOnCard?.card?.content,
  },
  descriptionText: {
    wordWrap: "break-word",
    ...theme.addOnCard?.card?.descriptionText,
  },
  header: {
    paddingBottom: 15,
    color: theme.addOnCard?.header?.textColor ?? theme.palette.primary.main,
    textDecoration: theme.addOnCard?.header?.textDecoration,
    fontWeight: theme.addOnCard?.header?.fontWeight,
  },
  box: {
    height: "100%",
    justifyContent: "center",
  },
  price: {
    textAlign: "right",
  },
  priceText: {
    color: theme.addOnCard?.price?.color ?? theme.palette.text.primary,
    fontFamily: theme.addOnCard?.price?.fontFamily,
    fontWeight: theme.addOnCard?.price?.fontWeight ?? theme.priceText?.fontWeight,
    alignSelf: theme.addOnCard?.price?.alignSelf,
  },
  priceTagWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  addText: {
    ...theme.addOnCard?.addText,
  },
  addTextDisabled: {
    ...theme.addOnCard?.addTextDisabled,
  },
  addTextSelected: {
    ...theme.addOnCard?.cardSelected?.addText,
  },
  h4: {
    color: theme.palette.primary.main,
  },
  addonBody: {
    fontFamily: theme.typography.fontFamily,
    "& .text-area": {
      fontFamily: theme.typography.fontFamily,
      "& p": {
        margin: 0,
      },
      "& ul": {
        "&.check": {
          paddingLeft: 0,
          listStyleType: "none",
          "& li": {
            background: `url("data:image/svg+xml;utf8,${theme.icons?.checkmarkIconCSS ?? ""}") no-repeat 0 2px`,
            backgroundSize: "25px 25px;",
            paddingLeft: theme.spacing(5) + "px",
            marginBottom: "8px",
            lineHeight: "28px",
            minHeight: "30px",
            marginLeft: 0,
            [theme.breakpoints.down("sm")]: {
              fontSize: "1rem",
              lineHeight: "28px",
              minHeight: "27px",
            },
          },
        },
      },
    },
    ...theme.addonUsp?.body,
  },
  button: {
    width: "200px",
    boxSizing: "border-box",
    backgroundColor: theme.radioButton?.backgroundColor ?? "#FFFFFF",
    border: theme.radioButton?.border ?? `1px solid ${theme.palette.divider}`,
    borderRadius: theme.radioButton?.borderRadius ?? theme.shape?.borderRadius,
    [theme.breakpoints.down("xs")]: {
      flexBasis: "calc(50% - 6px)",
    },
    [theme.breakpoints.down(400)]: {
      flexBasis: "100%",
    },
    "&:hover": {
      backgroundColor: theme.radioButton?.hoverBackgroundColor ?? "#FFFFFF",
    },
  },
  activeButton: {
    backgroundColor: theme.radioButton?.activeBackgroundColor ?? "#FFFFFF",
    border: theme.radioButton?.activeBorder ?? `1px solid ${theme.palette.primary.main}`,
    "& .MuiFormControlLabel-label": {
      fontWeight: theme.radioButton?.activeFontWeight ?? 500,
    },
  },
}));
